import { useTranslations } from '@components/context';
import { OUTCOME_ROW_ICON_CLASS } from '@components/PositionAutomation';
import StructuredList from '@components/core/StructuredList';
import FlowCard, { FLOW_CARD_VARIANT } from '@components/composites/FlowCard';
import Icon from '@components/core/Icon';
import SectionTitle from '@components/core/SectionTitle';

const OUTCOME_DEFAULT_ICON_CLASS = 'icon-svg-circle';

export function PositionFlowOutcomesSection({ outcomes, extendedRender }) {
    const { t } = useTranslations();

    return (
        <div className="position-flow-outcomes-block">
            <SectionTitle title={t('Outcome automations')} />
            <StructuredList className="position-flow-outcomes">
                {outcomes.map((outcome) => {
                    const outcomeId = outcome.value;
                    if (outcomeId == null) {
                        return null;
                    }
                    const iconClass = OUTCOME_ROW_ICON_CLASS[outcomeId] || OUTCOME_DEFAULT_ICON_CLASS;

                    return (
                        <StructuredList.Item
                            key={outcomeId}
                            data-type="outcome"
                        >
                            <FlowCard
                                className="position-flow-outcome-row__card recruitment-flow-step"
                                variant={FLOW_CARD_VARIANT.OUTCOME}
                                icon={<Icon value={iconClass} noMargin />}
                                title={outcome.text}
                                type={t('Outcome')}
                                body={extendedRender(outcomeId)}
                            />
                        </StructuredList.Item>
                    );
                })}
            </StructuredList>
        </div>
    );
}

export default PositionFlowOutcomesSection;
